/**
 * Afriex-internal dispute lifecycle status.
 *
 * Hoisted from `packages/server/src/domain/types/DisputeTypes.ts` and
 * `packages/admin/src/types/AfriexDispute.ts`, which agreed on all six values
 * but spelled the members differently. Member names follow the server copy,
 * which is the wire source of truth.
 */
export var AfriexDisputeStatus;
(function (AfriexDisputeStatus) {
    AfriexDisputeStatus["Created"] = "created";
    AfriexDisputeStatus["Pending"] = "pending";
    AfriexDisputeStatus["Closed"] = "closed";
    AfriexDisputeStatus["Fraud"] = "fraud";
    AfriexDisputeStatus["Reversed"] = "reversed";
    AfriexDisputeStatus["Legit"] = "legit";
})(AfriexDisputeStatus || (AfriexDisputeStatus = {}));
//# sourceMappingURL=AfriexDisputeStatus.js.map